<script>
import { mapState } from 'vuex';

import { flat } from '@/utils/flat';

// @vuese
// Komponent do sprawdzania uprawnień dla wskazanej encji
// @group Helpers
export default {
  name: 'CheckPermissionForExactEntity',
  props: {
    // Wymagane uprawnienie
    permissions: {
      type: [String, Array],
      required: false
    },
    // Identyfikator encji relacji uprawnienia
    permissionEntityId: {
      type: [String, Number],
      required: false
    },
    // Typ encji relacji uprawnienia
    permissionEntityType: {
      type: String,
      required: true
    },
    // Identyfikator(y) encji relacji roli
    roleEntityId: {
      type: [String, Number, Array],
      required: true
    },
    // Typ encji relacji roli
    roleEntityType: {
      type: String,
      required: true
    },
    joinType: {
      type: String,
      default: 'AND'
    }
  },
  computed: {
    permissionObjects() {
      if (!this.permissions || !this.permissions.length) {
        return;
      }

      const permissions = Array.isArray(this.permissions) ? this.permissions : [this.permissions];
      const roleEntityIds = Array.isArray(this.roleEntityId) ? this.roleEntityId : [this.roleEntityId];

      return flat(
        permissions.map(permission =>
          roleEntityIds.map(roleEntityId => ({
            permission: permission,
            roleRelationEntity: {
              entityId: roleEntityId.toString(),
              entityType: this.roleEntityType.toString()
            },
            permissionRelationEntity: {
              entityId: this.permissionEntityId.toString(),
              entityType: this.permissionEntityType.toString()
            }
          }))
        )
      );
    },
    permissionKeys() {
      if (!this.permissionObjects) {
        return;
      }
      return this.permissionObjects.map(permissionObject => JSON.stringify(permissionObject));
    },
    ...mapState({
      hasPermission(state) {
        if (!this.permissionKeys) {
          return true;
        }
        const checkedPermissions = state.auth.checkPermissionForExactEntity.permissions;
        switch (this.joinType) {
          case 'AND':
            return this.permissionKeys.every(permission => !!checkedPermissions[permission]);
          case 'OR':
            return this.permissionKeys.some(permission => !!checkedPermissions[permission]);
          default:
            return false;
        }
      }
    })
  },
  watch: {
    permissionObjects: {
      handler(permission) {
        this.checkPermissions(permission);
      },
      immediate: true
    }
  },
  methods: {
    // @vuese
    // Wysyłanie zapytania o uprawnienia
    checkPermissions(permissionObject) {
      this.$store.dispatch('auth/checkPermissionsForExactEntitySync', permissionObject);
    }
  },
  render() {
    if (this.hasPermission) {
      return this.$scopedSlots.default({});
    }
  }
};
</script>
